import { Injectable } from '@angular/core';
import { DataCoreService } from '../../../../services/data-core.service';
import { CtlBysIlgiGelenService } from '../ctl-bys-ilgi-gelen.service';

@Injectable(
 // {
  ///providedIn: 'root'
//}
)
export class CtlBysIlgiGelenAramaService {

  constructor(private dataCoreService: DataCoreService, private service: CtlBysIlgiGelenService) {}

  getData(control: any) {
          const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
          dataSource.select([]);

          
          const filterArr = [];
          if(this.service.birim) filterArr.push(['BirimKod', '=', this.service.birim]);
          dataSource.filter(filterArr)
          return dataSource;
  }
}
